import { render } from "./NewDetails.vue?vue&type=template&id=43b7e7ea"
import script from "./NewDetails.vue?vue&type=script&lang=js"
export * from "./NewDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__